module.exports = __webpack_public_path__ + "img/lapropharm plus.99ed56c3.png";